jQuery(function($) {
  $('.dropdown__button').on('click', function(e) {
    $(this).parent().toggleClass('dropdown--active');
    e.preventDefault();
  });

  $('.dropdown .menu__item a').on('click', function(e) {
    var link = $('.dropdown__button');
    var span = link.find('span.dropdown__arrow');
    link.html($(this).text());
    link.append(span);
    $('.dropdown').removeClass('dropdown--active');
    e.preventDefault();
  });

  $(document).on('click', function(e) {
    $('.dropdown--active').each(function() {
      var container = $(this);
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('dropdown--active');
      }
    });
  });
});
